import { mergeUniforms } from "three/src/renderers/shaders/UniformsUtils.js";
import TochiShader from "./TochiShader";
import { SkinChunk } from "./TochiShaderChunks";

export const TextureShader = (): TochiShader => {
    return {
        uniforms: mergeUniforms([
            SkinChunk.uniforms,
            {
                map: { value: null }
            }
        ]),
        vertexShader: `
      #include <tochi_skin_vert_premain>
      void main() {
        #include <tochi_skin_vert_main>
      }
    `,
        fragmentShader: `
        uniform sampler2D map;
        varying vec2 vUv;

        #include <tochi_skin_frag_premain>
        
        void main(){
            // Get luma
            vec4 tex = texture2D(map, vUv);
            gl_FragColor = tex;
            #include <tochi_skin_frag_main>
        }
    `
    };
};
